<template>
<main class="bg-main">
  <contenthead :section="sectionData" :lesson="lessonData" :contentsData="contentsData"></contenthead>

  <section class="container">

     <div class="heading-content-title">
      {{ $t('lesson.review.title') }}
    </div>

    <div class="buttons-at-the-bottom review">

      <div class="player-grammar">
        <vue-plyr ref="plyr" :options="playerOptions">
          <video playsinline crossorigin :data-poster="movieData.movie.poster">
            <source>
            <track kind="captions" label="Japanese" srclang="ja" :src="movieData.movie.subtitles">
            <track kind="captions" label="English" srclang="en" :src="movieData.movie.en_subtitles">
            <track kind="captions" label="Nepali" srclang="np" :src="movieData.movie.np_subtitles">
            <track kind="captions" label="Vietnamese" srclang="vn" :src="movieData.movie.vn_subtitles">
            <track kind="captions" label="Thai" srclang="th" :src="movieData.movie.th_subtitles">
            <track kind="captions" label="Indonesian" srclang="id" :src="movieData.movie.id_subtitles">
            <track kind="captions" label="Spanish" srclang="es" :src="movieData.movie.es_subtitles">
            <track kind="captions" label="Portuguese" srclang="pt" :src="movieData.movie.pt_subtitles">
            <track kind="captions" label="Korean" srclang="kr" :src="movieData.movie.kr_subtitles">
            <track kind="captions" label="China" srclang="cn" :src="movieData.movie.cn_subtitles">
            <track kind="captions" label="Taiwan" srclang="tw" :src="movieData.movie.tw_subtitles">
          </video>
        </vue-plyr>
      </div>


      <div class="buttons-side-by-side">
        <a class="button button-primary button-back" @click="back">{{ $t('common.button.back') }}</a>
        <a class="button button-primary button-grammar next" @click="nextStep">{{ $t('common.button.next') }}</a>
      </div>

    </div>

  </section>

</main>
</template>

<script>
  import {api, appEnv, useCoachmark} from './../../config';
  import learningLog from '../../mixins/learning-log';
  import status from '../../mixins/status';
  import {mapState} from 'vuex';
  import Hls from 'hls.js';

import componentContentHead from '../shared/ContentHead.vue';

import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

  export default {
    name: 'LessonReview',
    components: {
      'contenthead': componentContentHead,
    },
    mixins: [
      learningLog,
      status
    ],
    data () {
      return {
        step: 'review',
        lessonId: null,
        contents_data: {},
        playerOptions: {
          controls: [
            'play-large', // The large play button in the center
            // 'restart', // Restart playback
            // 'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
            'progress', // The progress bar and scrubber for playback and buffering
            'current-time', // The current time of playback
            'duration', // The full duration of the media
            'mute', // Toggle mute
            'volume', // Volume control
            'captions', // Toggle captions
            'settings', // Settings menu
            // 'pip', // Picture-in-picture (currently Safari only)
            // 'airplay', // Airplay (currently Safari only)
            // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
            'fullscreen' // Toggle fullscreen
          ]
        },
        authUser: null,
        driver: null,
        coachStep: 0,
        storage: {}
        
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      contentsData() {
        return this.contents_data;
      },
      movieData() {
        let contentKeys = Object.keys(this.$store.getters.lesson_content.review.content)
        return (this.$store.getters.lesson_content.review.content && contentKeys[0] in this.$store.getters.lesson_content.review.content) ? this.$store.getters.lesson_content.review.content[contentKeys[0]] : { movie: {}}
      },
    },

    created() {
      let self = this;
      
      this.authUser = this.$store.getters.getAuthUser;
      
      this.lessonId = this.$route.params['lesson_id']
      
      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }
      
      axios.get(api.contents, {
        params: {
          section_id: this.$store.getters.section_data.section_id,
          lesson_id: this.$store.getters.lesson_data.lesson_id,
          lesson_type: this.$store.getters.lesson_data.lesson_type
        }
      })
      .then((resp) => {
        this.contents_data = resp.data
      })
      
      this.coachStep = 0
    },

    mounted() {
      let self = this;
      
      if(appEnv !== 'local') {
        const TypeSquareJS = window.TypeSquareJS;
        TypeSquareJS.loadFont && TypeSquareJS.loadFont();
      }
      
      const myVideo = document.getElementsByTagName('video')[0];
      myVideo.addEventListener('webkitbeginfullscreen webkitendfullscreen', event => {
        if(event.type === 'webkitbeginfullscreen') {
            document.documentElement.style.setProperty('--webkit-text-track-display', 'block');
        } else {
            document.documentElement.style.setProperty('--webkit-text-track-display', 'none');
        }
      });

      // Set video path
      if (Hls.isSupported() && appEnv === 'production') {
        const hls = new Hls();
        hls.loadSource(this.movieData.movie.movie);
        hls.attachMedia(myVideo);
      } else {
        const source = document.getElementsByTagName('source')[0];
        source.setAttribute("src", this.movieData.movie.movie);
      }
      myVideo.load();
      
      
      const player = this.$refs.plyr.player
      player.on('loadeddata', event => {
        // categoryのcoach markはここで呼ぶ
        if(useCoachmark) {
          this.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
          
          const currentStep = this.step + '-' + this.stepSub
          
          const isCoachmarkDone = this.storage.getItem("coachmarkdone") ? JSON.parse(this.storage.getItem("coachmarkdone")) : null;
          if(!(isCoachmarkDone && currentStep in isCoachmarkDone && isCoachmarkDone[currentStep])) {
            this.showCoachMark();
          }
        }
      })
    
      player.on('play', event => {
        if(this.driver && this.driver.hasHighlightedElement()) {
          player.pause();
          if(this.driver.hasNextStep()) {
            this.driver.moveNext();
          } else {
            this.driver.reset();
          }
          return false
        } else {
          if(this.coachStep >= 1) {
            return true
          } else {
            return false
          }
        }
      });
    },
    methods: {
      nextStep() {
        if (this.$store.getters.lesson_content[this.step].status != 'completed' || this.movieData.status_review != 'completed') {
          this.statusContent('completed', this.step, { content_data_type: 'review', content_data_order: '1'});
        }
        this.learningTempLog();
        this.learningLog();
        
        this.$router.push({name: 'lesson.explanation', params: { lesson_id: this.lessonId, step: 'exam' }});
      },
      back() {
        let movieContentKeys = Object.keys(this.$store.getters.lesson_content.moviequiz.content)
        this.$router.push({name: 'lesson.quiz', params: { lesson_id: this.lessonId, content_order: movieContentKeys[movieContentKeys.length - 1] }});
      },
      initCoachMark() {
        if(this.driver) {
          this.driver.reset()
        } else {
          const driverOverlay = document.getElementById('driver-page-overlay')
          const driverStage = document.getElementById('driver-highlighted-element-stage')
          const driverItem = document.getElementById('driver-popover-item')
          const driverItem2 = document.getElementById('driver-popover-item2')
          
          if(driverOverlay) {
            driverOverlay.remove()
          }
          if(driverStage) {
            driverStage.remove()
          }
          if(driverItem) {
            driverItem.remove()
          }
        }
      },
      showCoachMark() {
        let self = this
        if(!this.authUser) return false;
        
         this.driver = new Driver({
            className: "scoped-class-dark",
            animate: true,
            opacity: 0.7,
            padding: 10,
            allowClose: true,
            overlayClickNext: false,
            DoneBtnText: "Done",
            CloseBtnText: "Close",
            NextBtnText: "Next",
            PrevBtnText: "Previous step",
            onDeselected: (e) => {
              if(this.driver.hasNextStep()) {
                return false
              }
            },
            onNext: (e) => {
              this.coachStep ++
            },
            onReset: (e) => {
              if(this.driver.hasNextStep()) {
                if((e &&'popover' in e) && !e.popover.node.classList.contains('popover-last')) {
                  setTimeout(() => {
                    this.driver.start(1);
                  }, 500)
                  return true
                }
              }
            
              let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
              if(!coachMarks) {
                coachMarks = {};
                coachMarks[this.step + '-' + this.stepSub] = true;
              } else {
                coachMarks[this.step + '-' + this.stepSub] = true;
              }

              this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
            }
        });
        
        this.driver.defineSteps([
        {
          element: '.plyr__control.plyr__control--overlaid',
          popover: {
            className: 'popover-class show-button',
            title: 'click to Play'
          }
        },
        {
          element: '.plyr__controls__item.plyr__menu button.plyr__control',
          popover: {
            className: 'popover-class show-button popover-last title-right footer-right',
            title: 'Here you can set the subtitle and speed settings.',
            position: 'top-right',
          }
        }
        ]);
        setTimeout(() => {
          this.driver.start();
        }, 300)
      }
    },
  }
</script>
